'use client';
'use strict';

var jsxRuntime = require('react/jsx-runtime');
var tailwindMerge = require('tailwind-merge');
var react = require('react');
var Typography = require('../../Base/Typography/Typography.js');
var Box = require('../../Base/Layouts/Box/Box.js');
require('../../Base/Layouts/FullBleed/FullBleed.js');

/**
 * 목차 네비게이션을 표시하는 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {Array<{title: string, index: number}>} props.data - 목차 항목들의 배열 ({title, index}[])
 * @param {(index: number) => void} [props.onChange] - 목차 항목 선택 시 호출되는 콜백 함수
 * @param {number} [props.currentIndex=0] - 현재 선택된 목차의 인덱스
 * @param {string} [props.className] - 컴포넌트에 적용할 추가 클래스명
 *
 * @example
 * ```tsx
 * const items = [
 *   { title: '소개', index: 0 },
 *   { title: '시작하기', index: 1 },
 *   { title: '사용방법', index: 2 }
 * ];
 *
 * <TableOfContents
 *   data={items}
 *   currentIndex={0}
 *   onChange={(index) => console.log(`선택된 항목: ${index}`)}
 * />
 * ```
 */ const TableOfContents = ({ data, onChange, currentIndex = 0, className })=>{
    const [animationDirection, setAnimationDirection] = react.useState(undefined);
    const handleTabClick = (index)=>{
        if (index === currentIndex) return setAnimationDirection(undefined);
        if (index > currentIndex) setAnimationDirection('down');
        if (index < currentIndex) setAnimationDirection('up');
        onChange === null || onChange === void 0 ? void 0 : onChange(index);
    };
    return jsxRuntime.jsxs(Box, {
        "data-testid": "design-system-table-of-contents",
        className: tailwindMerge.twMerge('relative flex h-auto w-[140px] flex-col', className),
        children: [
            jsxRuntime.jsx(Box, {
                "data-testid": "design-system-table-of-contents--gray-bar",
                className: "absolute left-0 top-0 z-0 my-1.5 h-[calc(100%_-_12px)] w-0.5 bg-w-gray-100"
            }),
            data.map((item)=>{
                const { title, index } = item;
                const isSelected = currentIndex == index;
                const generateSelectedSidebarStyle = (animationDirection)=>{
                    const direction = animationDirection === 'down' ? 'translate-y-1/2' : 'top-1/2 -translate-y-1/2';
                    return `transition duration-500 ease-out ${direction}`;
                };
                return jsxRuntime.jsxs(Box, {
                    "data-testid": isSelected ? 'design-system-table-of-contents--item-selected' : 'design-system-table-of-contents--item',
                    className: tailwindMerge.twMerge('relative flex h-9 w-full select-none items-center text-w-gray-400', isSelected && 'text-w-gray-600'),
                    onClick: ()=>handleTabClick === null || handleTabClick === void 0 ? void 0 : handleTabClick(index),
                    children: [
                        jsxRuntime.jsx("span", {
                            "data-testid": isSelected ? 'design-system-table-of-contents--bar-selected' : 'design-system-table-of-contents--bar',
                            className: tailwindMerge.twMerge('absolute -top-[6px] left-0 z-10 h-6 w-0.5 bg-transparent', isSelected && 'bg-primary', isSelected && generateSelectedSidebarStyle(animationDirection))
                        }),
                        jsxRuntime.jsx(Typography, {
                            variant: "body3",
                            className: tailwindMerge.twJoin('cursor-pointer pl-[18px]', isSelected && 'font-medium'),
                            children: title
                        })
                    ]
                }, index);
            })
        ]
    });
};

module.exports = TableOfContents;
